<template>
  <div class="app-container">
    <div class="forget-account-container" :class="isCollapse?'container-collapse':''">
      <pang-title :text="$router.lang.get('會員  中心')" eng="Account"/>
      <div class="tab-container">
        <pang-tab
        :tabs="tabs" v-model:current="currentTab"/>
        <div class="tab2-container">
          <pang-tab
          :tabs="tabs2" v-model:current="currentTab2"/>
        </div>
        <div class="password-container">
          <div class="input-label">{{$router.lang.get(currentTab2 == 0?'手機：':'信箱：')}}</div>
          <div class="input-container">
            <div class="select-container"
                v-if="currentTab2 == 0">
              <select v-model="areacode" @input="changeAreacode($event.target.value)">
                <option value="66">TH+66</option>
              </select>
            </div>
            <div :class="currentTab2 == 0?'phone-input':'email-input'">
              <pang-input
              ref="input"
              :placeholder="$router.lang.get(currentTab2 == 0?'請輸入手機號':'請輸入信箱')"
              :validate="currentTab2 == 0?phoneValidator:emailValidator"
              :name="currentTab2 == 0?'phone':'email'"
              v-model:value="value"/>
            </div>
          </div>
        </div>
        <div class="password-container">
          <div class="input-label">{{ $router.lang.get('賬號：') }}</div>
          <div class="input-label">{{ username?username:'-' }}</div>
        </div>
      </div>
          <div class="butt-container">
            <div>
              <pang-butt :text="$router.lang.get('取消')" @click="goback()" btype="account-cancel" :loading="loading"/>
            </div>
            <div>
              <pang-butt :text="$router.lang.get('確認')" @click="submit()" btype="account-submit" :loading="loading"/>
            </div>
          </div>
    </div>
  </div>
</template>

<script>

import { useScreenState } from '../../store';
import { PangTitle, PangTab, PangInput, PangButt } from '../../components'
import validate from "../../utils/validate";
import request from '../../api/request'
import message from '../../utils/message'


export default {
  name: "ForgetAccount",
  components: {
    PangTitle,
    PangTab,
    PangInput,
    PangButt,
  },
  data() {
    return {
      screenState: useScreenState(),
      currentTab: 0,
      tabs: [
        this.$router.lang.get('查詢賬號'),
        this.$router.lang.get('查詢密碼'),
      ],
      currentTab2: 0,
      tabs2: [
        this.$router.lang.get('手機找回'),
        this.$router.lang.get('信箱找回'),
      ],
      areacode: '66',
      email: '',
      phone: '',
      value: '',
      username: '',
      emailValidator: validate.email,
      loading: false,
    }
  },
  computed: {
    isCollapse() {
      return this.screenState.screenWidth < 900;
    },
  },
  methods: {
    phoneValidator (str) {
      return validate.phone(this.areacode + str)
    },
    changeAreacode (areacode) {
      this.areacode = areacode
      this.$refs.input.validateValue(this.value)
    },
    goback () {
      this.$router.back();
    },
    submit () {
      if (this.$refs.input.validateValue(this.value)) {
        let params = {}
        if (this.currentTab2 == 0) {
          params.phone = this.value.replace(/^0/, '')
          params.areacode = this.areacode
        }
        else {
          params.email = this.value
        }
        let _this = this
        this.loading = true
        request.get('/users', params, null).then(function (res) {
            if (res.status == 200) {
              if (res.data.results.length > 0) {
                _this.username = res.data.results[0].username;
              }
              else {
                message.showMessage(_this, _this.$router.lang.get('没找到賬號'))
                _this.username = ''
              }
            }
            else {
              message.resMessage(res, _this)
              _this.username = ''
            }
            _this.loading = false
        })
      }
    },
  },
  watch: {
    currentTab (val) {
      if (val == 1)
        this.$router.replace('/account/forgetpassword')
    },
    currentTab2 (val) {
      if (val == 0) {
        this.email = this.value
        this.value = this.phone
        this.$refs.input.validateValue(this.value)
      }
      else {
        this.phone = this.value
        this.value = this.email
        this.$refs.input.validateValue(this.value)
      }
    },
  },
};
</script>

<style>

.forget-account-container .pang-tab > div {
    max-width: 170px;
    width: 31.27vw;
}


.tab2-container .pang-tab {
    display: block;
}

.tab2-container .pang-tab > div {
    width: 120px;
    height: 30px;
    border-radius: 14px;
    line-height: 30px;
    text-align: center;
    margin-right: 20px;
    font-size: 14px;
    margin-top: 22px;
    display: inline-block;
}

.tab2-container .pang-tab > .inactive {
    border: 1px solid #A3A3A3;
    color: #67696D;
}

.tab2-container .active {
    background-color: #C5A76C;
    color: #FFFFFF;
    border: none;
}

</style>

<style scoped>

.forget-account-container {
  width: 90vw;
  max-width: 824px;
  margin-left: auto;
  margin-right: auto;
  color: #999999;
}

.tab2-container {
  margin-top: 30px;
  margin-bottom: 70px;
}

.password-container {
  display: flex;
  line-height: 46px;
  margin-bottom: 33px;
}

.input-label {
  width: 70px;
}

.input-container {
  width: calc(90vw - 70px);
  max-width: 724px;
  line-height: 24px;
  display: flex;
}

select {
  font-size: 16px;
  font-weight: 300;
  color: #999999;
  border: 1px solid #c7c7c7;
  border-radius: 4px;
  background-color: #fff;
  padding: 0 10px;
  width: 120px;
  height: 46px;
}

select:focus {
  outline: none !important;
  border: 1px solid #c7c7c7;
}

.select-container {
  width: 140px;
}

.phone-input {
  max-width: 400px;
  width: calc(100% - 140px);
}

.email-input {
  width: 100%;
  max-width: 540px;
}

.butt-container {
  display: flex;
}

.butt-container > div {
  max-width: 280px;
  width: calc(45vw - 20px);
  margin: 0 auto;
}

.butt-container > div:first-child {
  margin-right: 11px;
}

.butt-container > div:first-child > button {
  background-color: #C6C9CE;
}

.butt-container > div:last-child {
  margin-left: 12px;
}

.container-collapse select {
    font-size: calc(1vw + 7px);
    width: calc(100% - 10px);
}

.container-collapse .select-container{
    max-width: 140px;
    width: calc(14vw + 90px);
}

.container-collapse  .phone-input {
    width: calc(100% - 9vw + 90px);
}

.container-collapse .input-label[data-v-5f2f5254] {
    width: calc(5vw + 25px);
}

</style>